import { createContext } from "react";

export const CurrentPatientContext = createContext();
export const PatientsFilterContext = createContext();
export const ProtocolContext = createContext();
export const IgnoreClickOutsideContext = createContext();
